import React, { Context, ReactNode, useContext } from "react";
import { Button } from "@mui/material";
import { DynamicComponentProps } from "../../core/_models";

type Props = {
  children?: ReactNode
  context: Context<any>
  config: any
  values?: any;
}

export function SubmittableFormComponent({
                                           children, context, config, values
                                         }: Props) {
  const { action } = config;

  const formContext = useContext(context);

  const onSubmit = (e: any) => {
    e.preventDefault();

    if (action != null) {
      formContext.submit({ action, values });
    }
  };

  return (<form onSubmit={onSubmit}>
    {children}
  </form>);
}